// NOTE: Global `Window` augmentations merge across the entire program. The sibling
// package `@atlassian/conversation-assistant-service` declares this same
// `__ROVO_CHAT_CONFIG_PRODUCT__` global; keep the modifier (`?: string`) identical to
// that declaration, otherwise TS2687 ("All declarations of X must have identical
// modifiers") will fail at the program level.
declare global {
	interface Window {
		__ROVO_CHAT_CONFIG_PRODUCT__?: string;
	}
}

export const setRovoChatProduct = (product: string): void => {
	if (window) {
		window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
	}
};
